/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/brands': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<circle pid="0" cx="30" cy="30" r="30" _fill="#000"/><path pid="1" d="M12.347 11.77c.207-.599.854-.914 1.446-.706.591.209.904.864.698 1.463-1.748 5.073 1.72 8.86 4.364 10.89l1.07-1.548c.358-.517 1.162-.948 1.786-.957l5.995.027c.623-.01 1.553.28 2.064.642l17.664 12.518a1.93 1.93 0 01.464 2.666L39.87 48.369c-.6.867-1.562.763-2.417.157L19.788 36.008c-.511-.363-1.096-1.147-1.302-1.744l-1.877-5.978c-.205-.597-.08-1.508.278-2.026l.653-.942c-3.554-2.747-7.24-7.605-5.194-13.547zm8.218 17.777c1.37.97 3.256.633 4.215-.752a3.086 3.086 0 00-.744-4.267 2.995 2.995 0 00-3.513.034c.511.311.862.49.929.523.566.27.808.954.542 1.527-.194.417-.602.66-1.028.66-.162 0-.327-.036-.483-.11a14.156 14.156 0 01-1.165-.628 3.078 3.078 0 001.247 3.013z" _fill="#fff"/>'
  }
})
